import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as smoothscroll from "smoothscroll-polyfill";
import { googleAnalyticsHeadScripts } from './scripts/ga';
import 'hammerjs';

smoothscroll.polyfill();


export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}
googleAnalyticsHeadScripts();
platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts